module.exports = __webpack_public_path__ + "static/brush-yellow-circle-7bd720996056c8e3069edd8c826c3398.png";